import React from 'react';
import PropTypes from 'prop-types';
import ReceiptPrinterButton from 'views/FacilityAdmin/components/ReceiptPrinterButton';

export default function CustomReceiptPrinterButton({
  displayData,
  rawData,
}) {
  const data = displayData.map((item) => {
    const { dataIndex } = item;
    if (!rawData[dataIndex]) {
      return [];
    }
    const mealItemName = rawData[dataIndex].mealItemName;
    const deliveryStaffMealCountList = rawData[dataIndex]?.deliveryStaffMealCountList || [];
    return deliveryStaffMealCountList.map(({ orders }) => orders.map((order) => ({
      id: order.id,
      elder: order.elder,
      mealItems: order.mealItems.filter((mealItem) => mealItem.name === mealItemName),
      deliveryBy: order.deliveryBy,
      clientId: order.clientId,
      noteForMeal: order.noteForMeal,
      deliveryGroupId: order.deliveryGroupId,
    }))).flat();
  }).flat();

  return (
    <ReceiptPrinterButton data={data} />
  );
}

CustomReceiptPrinterButton.propTypes = {
  displayData: PropTypes.array,
  rawData: PropTypes.array.isRequired,
};
